<div class="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm p-4 animate-fade-in">
  <div class="bg-white w-full max-w-[480px] rounded-[24px] shadow-2xl overflow-hidden border border-[#E6E6E6] transform transition-all flex flex-col">
    <!-- Header -->
    <div class="flex items-center justify-between p-6 pb-4 bg-white">
      <h3 class="text-[20px] font-semibold text-[#121212]">Rate your Meal</h3>
      <button 
        (click)="closeModal()"
        class="w-[28px] h-[28px] rounded-full border border-[#E5E5E5] flex items-center justify-center text-[#1A1A1A] hover:bg-gray-50 transition-colors"
        type="button">
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1 1L11 11M1 11L11 1" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
        </svg>
      </button>
    </div>

    <!-- Subtitle (Info Notice) -->
    <div class="px-6 text-[12px] text-[#6A6A6A]">
      Date <span class="font-[600] text-[#121212]">{{ booking.date || 'Today' }}{{ (booking.servingTimeStart || booking.servingTimeEnd) ? ', ' : '' }}{{ booking.servingTimeStart || '12:30 PM' }}{{ booking.servingTimeEnd ? ' - ' + booking.servingTimeEnd : ' - 2:00 PM' }}</span>
      | Cafeteria <span class="font-[600] text-[#121212]">Main Hub - Level 4</span>
    </div>

    <!-- Body -->
    <div class="p-6 pt-4 flex-1">
      <div *ngIf="errorMessage" class="mb-4 p-3 bg-red-50 text-red-600 text-sm rounded-lg flex items-center gap-2">
        <svg class="w-4 h-4 shrink-0" fill="currentColor" viewBox="0 0 20 20">
          <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clip-rule="evenodd"/>
        </svg>
        <span>{{ errorMessage }}</span>
      </div>

      <div *ngIf="isAlreadyRated" class="mb-4 p-3 bg-amber-50 text-amber-800 text-sm rounded-lg flex items-center gap-2">
        <svg class="w-4 h-4 shrink-0 text-amber-600" fill="currentColor" viewBox="0 0 20 20">
          <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"/>
        </svg>
        <span>You have already rated this meal.</span>
      </div>

      <!-- Meal Card Box -->
      <div class="border border-[#E6E6E6] rounded-[20px] p-[16px] bg-white flex flex-col gap-[16px] mb-5">
        <!-- Meal Info Row -->
        <div class="flex items-center gap-[16px]">
          <img 
            *ngIf="booking.image"
            [src]="booking.image" 
            class="w-[72px] h-[72px] rounded-[16px] object-cover bg-gray-50 border border-[#F2F2F2]" 
            alt="meal"
          />
          <div *ngIf="!booking.image" class="w-[72px] h-[72px] rounded-[16px] bg-[#F5F5F5] border border-[#E6E6E6] flex items-center justify-center shrink-0">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#98A2B3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M3 2v7c0 1.1.9 2 2 2h4a2 2 0 0 0 2-2V2"></path>
              <path d="M7 2v20"></path>
              <path d="M21 15V2v0a5 5 0 0 0-5 5v6c0 1.1.9 2 2 2h3Zm0 0v7"></path>
            </svg>
          </div>
          <div class="flex-1 min-w-0">
            <h4 class="text-[15px] font-semibold text-[#121212] truncate leading-tight">{{ booking.mealName }}</h4>
            <p class="text-[13px] text-[#6A6A6A] mt-0.5 truncate">By {{ booking.vendor || 'Unknown Vendor' }}</p>
            
            <div class="flex flex-wrap gap-[8px] mt-2">
              <span class="bg-[#1A73E8] text-white rounded-[6px] text-[10px] font-bold px-[8px] py-[3px] uppercase tracking-wider">
                {{ booking.category || 'Lunch' }}
              </span>
              <span class="bg-[#F5F5F5] text-[#121212] rounded-[6px] text-[10px] font-bold px-[8px] py-[3px] uppercase tracking-wider">
                Halal
              </span>
            </div>
          </div>
        </div>

        <!-- Star Picker Row inside Card -->
        <div class="bg-[#F5F5F5] rounded-[12px] p-[14px_18px] flex items-center justify-between">
          <span class="text-[13px] font-medium text-[#121212]">Tap on the star to rate</span>
          
          <div class="flex items-center gap-1" (mouseleave)="clearHoveredStar()">
            <button
              *ngFor="let star of [1,2,3,4,5]"
              type="button"
              [disabled]="isAlreadyRated || isReadOnly || isSubmitting"
              (mouseenter)="setHoveredStar(star)"
              (click)="setRating(star)"
              class="p-0.5 focus:outline-none transition-transform hover:scale-110 disabled:cursor-not-allowed">
              
              <!-- Star icon (solid or outlined) -->
              <svg 
                class="w-[24px] h-[24px] transition-colors"
                [class.text-[#F3A218]]="star <= (hoveredStar || rating)"
                [class.text-gray-300]="star > (hoveredStar || rating)"
                fill="none"
                stroke="currentColor"
                stroke-width="1.5"
                viewBox="0 0 24 24">
                <!-- If star is selected/hovered, use solid style else outline style -->
                <path 
                  *ngIf="star <= (hoveredStar || rating)"
                  fill="currentColor"
                  stroke="none"
                  d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/>
                <path 
                  *ngIf="star > (hoveredStar || rating)"
                  stroke-linecap="round" 
                  stroke-linejoin="round" 
                  d="M11.48 3.499c.196-.612 1.062-.612 1.258 0l2.032 6.257a1 1 0 00.95.69h6.582c.643 0 .91.823.394 1.218l-5.326 4.1a1 1 0 00-.364 1.118l2.032 6.257c.196.612-.468 1.096-.988.69L12 19.5a1 1 0 00-1.173 0l-5.334 4.1c-.52.406-1.183-.078-.988-.69l2.03-6.257a1 1 0 00-.364-1.118L.785 11.662c-.515-.395-.248-1.217.395-1.217h6.581a1 1 0 00.95-.69l2.03-6.257z" />
              </svg>
            </button>
          </div>
        </div>
      </div>

      <!-- Comment Section -->
      <div class="flex flex-col gap-2">
        <label for="meal-comment" class="text-[13px] font-medium text-[#6A6A6A]">Comment</label>
        <div class="relative w-full">
          <textarea
            id="meal-comment"
            [(ngModel)]="comment"
            [disabled]="isAlreadyRated || isReadOnly || isSubmitting"
            [maxLength]="maxCommentLength"
            rows="3"
            placeholder="Your comment go here"
            class="w-full border border-[#E6E6E6] rounded-[12px] p-[12px_16px] text-[14px] focus:outline-none focus:ring-1 focus:ring-[#BE2F27] placeholder-[#A3A3A3] min-h-[90px] pr-[40px] resize-none transition disabled:bg-gray-50 disabled:text-gray-500">
          </textarea>
          <!-- Clear Button -->
          <button 
            *ngIf="comment && !isAlreadyRated && !isReadOnly && !isSubmitting"
            (click)="comment = ''"
            type="button"
            class="absolute top-3 right-3 text-[#A3A3A3] hover:text-[#121212] transition-colors">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </button>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <div class="flex items-center justify-end gap-3 p-6 pt-0 bg-white">
      <button 
        type="button" 
        (click)="closeModal()" 
        class="border border-[#E6E6E6] bg-white rounded-[12px] h-[48px] px-[24px] text-[14px] font-semibold text-[#121212] hover:bg-gray-50 transition-colors">
        Cancel
      </button>
      <button 
        *ngIf="!isAlreadyRated && !isReadOnly"
        type="button" 
        (click)="submitRating()" 
        [disabled]="rating === 0 || isSubmitting"
        class="bg-[#BE2F27] hover:bg-[#a12821] disabled:bg-gray-300 disabled:cursor-not-allowed text-white rounded-[12px] h-[48px] px-[24px] text-[14px] font-semibold flex items-center gap-[8px] transition-all shadow-sm">
        <span *ngIf="isSubmitting" class="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
        <span>Rate Meal</span>
        <svg *ngIf="!isSubmitting" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M6 12L10 8L6 4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
    </div>
  </div>
</div>
